import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { blogPosts } from '../../data/blogPosts';
import './BlogLayout.css';

const BlogPage = () => {
  const sortedPosts = [...blogPosts].sort((a, b) => new Date(b.date) - new Date(a.date));

  return (
    <main className="blog-redesign">
      <Helmet>
        <title>Blog - Tips, Guides & News</title>
        <meta name="description" content="Read the latest tips and guides on Global Entry, TSA PreCheck, and how to secure your interview appointment fast." />
        <link rel="canonical" href="https://www.easyglobalentry.com/blog" />
      </Helmet>

      <section className="blog-hero">
        <div className="blog-hero__inner">
          <h1 className="blog-hero__heading">The Global Entry Blog</h1>
          <p className="blog-hero__subtitle">
            Expert tips, detailed guides, and the latest news to help you speed through the airport.
          </p>
        </div>
      </section>

      <section className="blog-grid-section">
        <div className="blog-grid-section__inner">
          <div className="blog-grid">
            {sortedPosts.map((post) => (
              <Link to={`/blog/${post.slug}`} key={post.id} className="blog-card">
                <div className="blog-card__image-wrapper">
                  <img 
                    src={post.imageUrl} 
                    alt={post.title} 
                    className="blog-card__image"
                  />
                </div>
                <div className="blog-card__content">
                  <div className="blog-card__meta">
                    <span className="blog-card__category">{post.category || 'GUIDE'}</span>
                    <span className="blog-card__date">
                      {new Date(post.date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}
                    </span>
                  </div>
                  <h2 className="blog-card__title">{post.title}</h2>
                  <p className="blog-card__excerpt">
                    {post.excerpt.length > 120 ? post.excerpt.substring(0, 120) + '...' : post.excerpt}
                  </p>
                  <div className="blog-card__cta">
                    Read Article <span className="blog-card__cta-arrow">→</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default BlogPage;
